/**
 * BETA — pharmacie settings + branding + payments.
 */
import { nowIso, dateOffsetYmd } from "./_utils.js";
import { buildHistoriquePaiements } from "../data/modules.js";

export function register(route) {
  route("GET", "/pharmacie", (ctx) => {
    const p = ctx.store.data.pharmacie;
    const counts = ctx.store.data.users.reduce(
      (acc, u) => ({ ...acc, [u.role]: (acc[u.role] || 0) + 1 }),
      {},
    );
    return {
      ...p,
      licence: p.licence,
      modules: (ctx.store.data.modules || []).filter((m) => m.active),
      role_counts: {
        PROPRIETAIRE: counts.PROPRIETAIRE || 0,
        MANAGER: counts.MANAGER || 0,
        CAISSIER: counts.CAISSIER || 0,
      },
    };
  });

  route("PATCH", "/pharmacie", (ctx) => {
    Object.assign(ctx.store.data.pharmacie, ctx.body || {});
    ctx.commit();
    return ctx.store.data.pharmacie;
  });

  route("POST", "/pharmacie/logo", (ctx) => {
    ctx.store.data.pharmacie.logo_url = "/uploads/demo-logo.png";
    ctx.commit();
    return ctx.store.data.pharmacie;
  });

  route("DELETE", "/pharmacie/logo", (ctx) => {
    ctx.store.data.pharmacie.logo_url = null;
    ctx.commit();
    return ctx.store.data.pharmacie;
  });

  route("GET", "/pharmacie/payments/pending", () => [
    {
      id: "pay-pending-demo",
      module_code: "BACKUP_AUTO",
      montant: 25000,
      url_chargily: null,
      expires_at: dateOffsetYmd(1) + "T23:59:59.000Z",
      created_at: nowIso(),
    },
  ]);

  route("GET", "/pharmacie/payments/history", () => buildHistoriquePaiements());

  route("POST", "/pharmacie/payments/:id/regenerate", () => ({
    url_chargily: "https://demo.chargily.io/checkout/regenerated",
    expires_at: dateOffsetYmd(1) + "T23:59:59.000Z",
  }));
}
